// extracted by mini-css-extract-plugin
module.exports = {"list":"AdminPanel_list__1HW12","wrapper":"AdminPanel_wrapper__3dgTl"};